import { render, staticRenderFns } from "./ReferToFacilityModal.vue?vue&type=template&id=787a5190&"
import script from "./ReferToFacilityModal.vue?vue&type=script&lang=js&"
export * from "./ReferToFacilityModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferToFacilityModal.vue?vue&type=style&index=0&id=787a5190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports